/* ============================================================
   Craft Com : paiement de l'acompte (50 %) pour lancer le projet
   Le client paie via le checkout Shopify ; le brief complet est
   joint à la commande (note + infos supplémentaires).
   Se charge APRÈS app.js (réutilise SERVICES, state, computeTotals).
   ============================================================ */
document.addEventListener('DOMContentLoaded', function () {
  var RATE = 0.5;
  // Un produit Shopify "Acompte 50 % – …" par prestation (id de sa variante)
  var VARIANTS = {
    flyer:       60112141451648, // acompte-flyer
    board:       60112141484416, // acompte-menu-board-digital
    print:       60112141517184, // acompte-menu-print
    cartevisite: 60112141549952, // acompte-carte-de-visite
    snap:        60112141582720, // acompte-filtre-snapchat
    video:       60112141648256, // acompte-video-ia
    motion:      60112141877632, // acompte-video-motion-design
    motionvo:    60112141910400, // acompte-video-motion-design-voix-off
    shopify:     60112141943168, // acompte-site-shopify
    siteessentiel: 60135336706432, // acompte-site-essentiel
    sitepro:       60135336739200, // acompte-site-pro
    sitemachine:   60135336771968  // acompte-site-machine-a-clients
  };
  var ALL_IDS = Object.keys(VARIANTS).map(function (k) { return VARIANTS[k]; });

  var payBtn = document.getElementById('payBtn');
  if (!payBtn || typeof SERVICES === 'undefined') return;
  var payAmt = document.getElementById('payAmt');
  var payNote = document.getElementById('payNote');
  var recapDep = document.getElementById('recapDeposit');

  var fmt = function (n) { return n.toLocaleString('fr-FR', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 }) + ' €'; };

  function selection() {
    var items = [], deposit = 0, quote = false;
    SERVICES.forEach(function (s) {
      var st = state[s.id];
      if (!st || !st.sel) return;
      if (s.quote || !VARIANTS[s.id]) { quote = true; return; }
      var qty = s.unit ? st.qty : 1;
      deposit += s.price * RATE * qty;
      items.push({ id: VARIANTS[s.id], quantity: qty });
    });
    return { items: items, deposit: Math.round(deposit * 100) / 100, quote: quote };
  }

  function render() {
    var sel = selection();
    if (payAmt) payAmt.textContent = sel.deposit ? fmt(sel.deposit) : '';
    if (recapDep) recapDep.innerHTML = fmt(sel.deposit);
    payBtn.disabled = !sel.items.length;
    if (payNote) {
      payNote.textContent = !sel.items.length
        ? (sel.quote ? 'Cette prestation est sur devis : écrivez-nous sur WhatsApp, nous vous enverrons un lien de paiement.' : 'Sélectionnez au moins une prestation pour payer l\'acompte.')
        : 'Paiement sécurisé. Vous payez 50 % maintenant, le reste à la livraison.' + (sel.quote ? ' Les prestations sur devis seront chiffrées à part.' : '');
    }
  }
  render();
  document.addEventListener('craftcom:selection-updated', render);

  /* ---- fichiers : hébergés par Shopify, liens joints à la commande ---- */
  var MAX_FILES = 6, MAX_SIZE = 20 * 1024 * 1024;
  function addWithFiles(first, files) {
    // 1re prestation envoyée en multipart avec les fichiers en "propriétés"
    var fd = new FormData();
    fd.append('id', first.id);
    fd.append('quantity', first.quantity);
    var skipped = [];
    Array.prototype.slice.call(files || [], 0, MAX_FILES).forEach(function (f, i) {
      if (f.size > MAX_SIZE) { skipped.push(f.name); return; }
      fd.append('properties[Fichier ' + (i + 1) + ']', f, f.name);
    });
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: fd })
      .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); })
      .then(function (item) {
        var links = Object.keys(item.properties || {}).map(function (k) { return item.properties[k]; });
        return { links: links, skipped: skipped };
      });
  }

  function chipVal(id) { var c = document.querySelector('#' + id + ' .chip.on'); return c ? c.dataset.val : ''; }
  function val(id) { var el = document.getElementById(id); return el ? el.value.trim() : ''; }
  function flag(el) { el.style.borderColor = 'var(--gold)'; el.focus(); el.addEventListener('input', function () { el.style.borderColor = ''; }, { once: true }); }

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }

  payBtn.addEventListener('click', function () {
    var sel = selection();
    if (!sel.items.length) return;
    var name = val('f-name');
    if (!name) { flag(document.getElementById('f-name')); return; }
    var socBtn = document.querySelector('.soc-opt.on');
    if (!socBtn) {
      var t = document.getElementById('socialToggle');
      t.scrollIntoView({ behavior: 'smooth', block: 'center' });
      t.animate([{ transform: 'translateX(0)' }, { transform: 'translateX(-6px)' }, { transform: 'translateX(6px)' }, { transform: 'translateX(0)' }], { duration: 300 });
      return;
    }
    var social = socBtn.dataset.soc === 'snap' ? 'Snapchat' : 'Instagram';
    var attrs = {
      'Nom': name,
      'Entreprise': val('f-biz'),
      'Contact': social + ' : ' + (val('f-pseudo') || '(non renseigné)'),
      'WhatsApp': val('f-wa'),
      'E-mail': val('f-mail'),
      'Prestations': (typeof selectionSummary === 'function' ? selectionSummary() : ''),
      'Deadline': chipVal('chipsDeadline'),
      'Budget': chipVal('chipsBudget'),
      'Projet': val('f-msg')
    };
    Object.keys(attrs).forEach(function (k) { if (!attrs[k]) delete attrs[k]; });

    var label = payBtn.querySelector('.lbl');
    var old = label.textContent;
    payBtn.disabled = true;
    label.textContent = 'Préparation du paiement…';

    var fileInput = document.getElementById('f-file');
    var files = fileInput && fileInput.files && fileInput.files.length ? fileInput.files : null;
    var extra = files && files.length > MAX_FILES ? (files.length - MAX_FILES) : 0;
    if (files) label.textContent = 'Envoi de vos fichiers…';

    // retire d'anciens acomptes du panier (garde les autres produits, ex. plaques NFC)
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
      var updates = {};
      cart.items.forEach(function (it) { if (ALL_IDS.indexOf(it.variant_id) !== -1 || it.handle === 'acompte-projet') updates[it.key] = 0; });
      return Object.keys(updates).length ? post('/cart/update.js', { updates: updates }) : null;
    }).then(function () {
      var first = sel.items[0], rest = sel.items.slice(1);
      var step = files
        ? addWithFiles(first, files).catch(function () { return post('/cart/add.js', { items: [first] }).then(function () { return { links: [], failed: true }; }); })
        : post('/cart/add.js', { items: [first] }).then(function () { return null; });
      return step.then(function (up) {
        return (rest.length ? post('/cart/add.js', { items: rest }) : Promise.resolve()).then(function () { return up; });
      });
    }).then(function (up) {
      if (up) {
        var lines = up.links.slice();
        if (up.failed) lines.push(files.length + ' fichier(s) à envoyer sur WhatsApp (envoi en ligne échoué)');
        (up.skipped || []).forEach(function (n) { lines.push(n + ' : trop lourd, à envoyer sur WhatsApp'); });
        if (extra) lines.push('+ ' + extra + ' autre(s) fichier(s) à envoyer sur WhatsApp');
        if (lines.length) attrs['Fichiers'] = lines.join('\n');
      }
      var note = 'DEMANDE DE PROJET : acompte 50 %\n\n' + Object.keys(attrs).map(function (k) { return k + ' : ' + attrs[k]; }).join('\n');
      label.textContent = 'Préparation du paiement…';
      return post('/cart/update.js', { note: note, attributes: attrs });
    }).then(function () {
      location.href = '/checkout';
    }).catch(function (err) {
      console.warn('Acompte', err);
      payBtn.disabled = false;
      label.textContent = old;
      if (payNote) payNote.textContent = 'Le paiement n\'a pas pu démarrer. Réessayez, ou écrivez-nous sur WhatsApp.';
    });
  });
});
